import { browser } from '$app/environment';
import { toFeatureFlags } from '$lib/services/legacy/iddqd/flags';
import { KeycloakClient } from './keycloak-client';
import { SpineAuth } from './spine-auth';
import type { Bootstrap } from './types';

export const NAMESPACE = 'spine-auth';

let instance: SpineAuth;
/** Creates the instance with refreshed tokens. If called multiple times from the browser the same instance will be returned with refreshed tokens. */
export const createOrRefreshInstance = async (
    bootstrap: Bootstrap,
    marketSlug: string,
    requestURL: URL,
    fetch: typeof global.fetch
) => {
    const keycloak = KeycloakClient.createForMarket(
        marketSlug,
        toFeatureFlags(requestURL.searchParams)
    );
    const createInstance = () =>
        new SpineAuth(bootstrap, fetch, keycloak).refreshTokensIfNeeded(requestURL);
    if (!browser) {
        return await createInstance();
    }
    if (instance) {
        return await instance.refreshTokensIfNeeded(requestURL);
    }
    instance = await createInstance();
    return instance;
};

/** Returns the instance with refreshed tokens. This is *only* supported from the browser. */
export const getAuth = async () => {
    if (!browser) {
        throw Error('getAuth() can only be called from the browser');
    }
    if (!instance) {
        throw Error('createOrRefreshInstance() must be invoked before calling getAuth()');
    }
    return await instance.refreshTokensIfNeeded();
};
